<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              note_add
            </v-icon>
            <h3
              class="title ml-2"
            >
              Change Payment Provider
            </h3>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="isVisible = false"
            >
              X
            </v-btn>
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            <v-container
              grid-list-md
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex xs12>
                  <h6 class="subheading">
                    Email Details
                  </h6>
                </v-flex>

                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="holderIds"
                    label="Holder IDs"
                    disabled
                  />
                </v-flex>

                <v-flex
                  xs12
                  md12
                >
                  <v-select
                    v-model="formData.paymentProvider"
                    :items="paymentProviders()"
                    label="Payment Provider"
                    item-key="id"
                    item-text="name"
                    item-value="id"
                    :error-messages="getFieldErrors('paymentProvider')"
                    @input="$v.formData.paymentProvider.$touch()"
                    @blur="$v.formData.paymentProvider.$touch()"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-alert
              v-for="e in error"
              :key="e.path"
              :value="error"
              type="error"
              color="error"
            >
              {{ e.message }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="isVisible = false"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading || $v.$invalid"
                  :loading="isLoading"
                  color="primary"
                  @click="submit"
                  v-on="on"
                >
                  Change
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
        <v-snackbar
          v-model="snackbarShow"
          :color="snackbarColor"
          :auto-height="true"
        >
          <ul v-if="snackbarErrors">
            <li
              v-for="snackbarError in snackbarErrors"
              :key="snackbarError.message"
            >
              {{ snackbarError.message }}
            </li>
          </ul>

          <div
            v-if="snackbarMessage"
          >
            {{ snackbarMessage }}
          </div>

          <v-btn
            color="primary"
            text
            @click="snackbarShow = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ChangePaymentProviderDialog',
  components: {
  },
  props: {
    visible: Boolean,
    payoutId: {
      type: String,
      required: true,
    },
    holderIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      error: null,
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      formData: {
        paymentProvider: null,
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  mounted() {
    this.formData = {
      ...this.formData,
      ...(this.serializePayout(this.payout)),
    };

    this.$v.$touch();
  },
  methods: {
    paymentProviders() {
      const data = this.$store.getters.getPaybackTypes;
      if (!data || !data.payback || !data.payback.paymentProviderOptions) {
        return [];
      }

      return this.transformEnumToSelectArray(data.payback.paymentProviderOptions);
    },
    transformEnumToSelectArray(options) {
      const newOptions = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(options)) {
        newOptions.push({
          id: key,
          name: value,
        });
      }

      return newOptions;
    },
    getFieldErrors(field) {
      const errors = [];
      const formField = this.$v.formData[field];

      if (formField) {
        if (!formField.$dirty || !formField.$invalid) {
          return errors;
        }

        if (!formField.required) {
          errors.push('Required field');
        }

        if (!formField.minLength) {
          errors.push('Field has a minimum length');
        }

        if (!formField.maxLength) {
          errors.push('Field has a maximum length');
        }
      }

      return errors;
    },
    serializePayout(payout) {
      const { ...serializePayout } = payout;

      return {
        ...serializePayout,
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;

      this.$store.dispatch('changePaymentProviderPatPayback', {
        payoutId: this.payoutId,
        payload: {
          paymentProvider: this.formData.paymentProvider,
          holderIds: this.holderIds,
        },
      })
        .then(() => {
          this.isLoading = false;
          this.isVisible = false;

          this.snackbarShow = true;
          this.snackbarErrors = [];
          this.snackbarMessage = 'Changing Payment Provider was successful.';
          this.snackbarColor = 'success';
        })
        .catch((error) => {
          this.isLoading = false;

          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
  },
  validations() {
    return {
      formData: {
        paymentProvider: { required },
      },
    };
  },
};
</script>

<style lang="scss">
.create-bridge-signing {
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    max-width: 133%;
    height: 20px;
    left: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -20px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
  .v-input--selection-controls.v-input .v-label {
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payback/ChangePaymentProviderDialog.vue